import { createQueryKeys } from '@lukemorales/query-key-factory'

export const feeds = createQueryKeys('feeds', {
  userFeed: (userId: number, publicFeed = false) => ({
    queryKey: [userId, publicFeed],
  }),
  timeline: null,
  post: (postId: string) => ({
    queryKey: [postId],
    contextQueries: {
      comments: null,
      likes: null,
    },
  }),
  comment: (commentId: string) => ({
    queryKey: [commentId],
    contextQueries: {
      comments: null,
      likes: null,
    },
  }),
})
